// ===================================================================
// KAIXO - SharedContactProfile
// ===================================================================
// Ficha de un contacto KAIXO compartido en el chat — estilo NATIVO
// (Android/iOS Contactos): header con foto grande circular + nombre,
// secciones por bloques (Teléfono, Email, Idioma, Región/País, Handle).
// Botón principal "Añadir a contactos" + secundario "Cerrar".
// Aislado en su propia carpeta — no toca UserInfoModal.
// ===================================================================

import React from 'react';
import ReactDOM from 'react-dom';
import { Icons } from '../Icons/Icons';
import useModalClose from '../../hooks/useModalClose';
import t from '../../i18n/useTranslation';
import './SharedContactProfile.css';

export default function SharedContactProfile({
    contact,        // { userId, name, avatar, phone, email, handle, language, region, country }
    canAddToPhone = true,
    onAddToPhone,
    onClose
}) {
    useModalClose(onClose);
    if (!contact) return null;

    const initial = (contact.name || '?').charAt(0).toUpperCase();
    const placeBits = [contact.region, contact.country].filter(Boolean);
    const place = placeBits.join(', ');

    const Row = ({ label, value, mono = false }) => {
        if (!value) return null;
        return (
            <div className="scp-row">
                <div className="scp-row-label">{label}</div>
                <div className={`scp-row-value ${mono ? 'scp-row-mono' : ''}`}>{value}</div>
            </div>
        );
    };

    return ReactDOM.createPortal(
        <div className="scp-overlay" onClick={onClose}>
            <div className="scp-modal" onClick={e => e.stopPropagation()}>
                <button className="scp-close" onClick={onClose} aria-label={t.chat.contactCard.close}>
                    <Icons.Close size={18} color="white" />
                </button>

                <div className="scp-header">
                    <div className="scp-avatar">
                        {contact.avatar
                            ? <img src={contact.avatar} alt="" />
                            : <span>{initial}</span>}
                    </div>
                    <h2 className="scp-name">{contact.name || t.chat.contactCard.noName}</h2>
                    {contact.handle && <div className="scp-handle">@{contact.handle}</div>}
                </div>

                <div className="scp-section">
                    <Row label={t.chat.contactCard.labelPhone} value={contact.phone} mono />
                    <Row label={t.chat.contactCard.labelEmail} value={contact.email} />
                    <Row label={t.chat.contactCard.labelLanguage} value={contact.language} />
                    <Row label={t.chat.contactCard.labelPlace} value={place} />
                </div>

                <div className="scp-actions">
                    {canAddToPhone && contact.phone && (
                        <button
                            type="button"
                            className="scp-btn scp-btn-primary"
                            onClick={() => onAddToPhone?.(contact)}
                        >
                            {t.chat.contactCard.add}
                        </button>
                    )}
                    <button
                        type="button"
                        className="scp-btn scp-btn-secondary"
                        onClick={onClose}
                    >
                        {t.chat.contactCard.close}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
